import { ButtonStateType } from '@kubit/web-ui-components/button/types';
import { commonStyles } from '../commonStyles';
import { ButtonVariantType } from '../variants';
export const getPrimaryStyles = (FOUNDATIONS, FONT) => {
    return {
        [ButtonVariantType.PRIMARY]: {
            [ButtonStateType.DEFAULT]: {
                ...commonStyles(FOUNDATIONS),
            },
            [ButtonStateType.HOVER]: {
                ...commonStyles(FOUNDATIONS),
                background_color: FOUNDATIONS.color_comp_actions_button_primary_hover_bg,
                color: FOUNDATIONS.color_comp_actions_button_primary_hover_font,
                icon: {
                    ...commonStyles(FOUNDATIONS).icon,
                    color: FOUNDATIONS.color_comp_actions_button_primary_hover_icon,
                },
            },
            [ButtonStateType.PRESSED]: {
                ...commonStyles(FOUNDATIONS),
                background_color: FOUNDATIONS.color_comp_actions_button_primary_pressed_bg,
                color: FOUNDATIONS.color_comp_actions_button_primary_pressed_icon,
                icon: {
                    ...commonStyles(FOUNDATIONS).icon,
                    color: FOUNDATIONS.color_comp_actions_button_primary_pressed_icon,
                },
            },
            [ButtonStateType.LOADING]: {
                ...commonStyles(FOUNDATIONS),
                background_color: FOUNDATIONS.color_comp_actions_button_primary_loading_bg,
                cursor: 'not-allowed',
                pointer_events: 'none',
            },
            [ButtonStateType.DISABLED]: {
                ...commonStyles(FOUNDATIONS),
                background_color: FOUNDATIONS.color_accent_disabled_bg_200,
                color: FOUNDATIONS.color_accent_disabled_font_100,
                icon: {
                    ...commonStyles(FOUNDATIONS).icon,
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
                cursor: 'not-allowed',
                pointer_events: 'none',
            },
        },
    };
};
//# sourceMappingURL=primary.js.map